import styled from 'styled-components';

const SunEditorStyle = styled.div`
  .se-dialog-tabs {
    display: none;
  }

  .se-image-upload .se-style {
    display: none;
  }

  .hidden-file-input {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;
  }

  .custom-file-button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    z-index: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0px 10px;
    line-height: 34px;
    font-size: 14px;
  }
  .se-input-form._se_image_file {
    opacity: 0;
    position: relative;
    z-index: 100;
  }
  .sun-editor .se-dialog .se-dialog-inner .se-dialog-form:nth-child(2),
  .sun-editor .se-dialog .se-dialog-inner .se-dialog-body > *:not(:first-child),
  .sun-editor .se-dialog .se-dialog-inner .se-dialog-footer > div,
  .sun-editor .se-controller .se-btn-group .se-tooltip:nth-child(7) {
    display: none;
  }
  .sun-editor .se-dialog .se-dialog-inner .se-dialog-body > div:first-child {
    border: none !important;
  }
  .sun-editor .se-dialog .se-dialog-inner .se-dialog-form .se-input-form {
    height: 37px;
  }

  .ant-form-item-control-input-content {
    position: relative;
    .btn-upload {
      position: absolute;
      top: 5px;
      left: 185px;
      z-index: 100;
      opacity: 0.3;
      cursor: pointer;
      width: 34px;
      height: 34px;
      border: 6px;
    }
    .btn-upload:hover {
      background-color: #e1e1e1;
      border-color: #d1d1d1;
      outline: 0 none;
    }
  }
`;

export default SunEditorStyle
